import { h, Component } from 'preact';
import cx from 'classnames';
import style from './style';
import { Icon, getSubnav, navItemIsCurrent } from '@cube/blocks';
import LinkEvent, { linkEventLabel } from '../../../linkevent';
import { Column } from '@cube/layout';

export class MobileHorizontalNav extends Component {
	state = {
		hideNav: false,
		scrollPosition: 0,
		initialRender: true,
		disableHorizontalNav: false,
		allowHideNavigation: true
	}

	hideHorizontalNav = () => {
		this.setState({ disableHorizontalNav: true });
	}

	componentDidUpdate(nextProps) {
		// if page path changes while horizontal nav is disabled, reset disableHorizontalNav
		if (nextProps.current !== this.props.current && !this.state.disableHorizontalNav) {
			/* eslint-disable-next-line */
			this.setState({ disableHorizontalNav: false });
		}
	}

	renderItems = (current = '', links = [], primaryLabel, theme) => {
		let nav = getSubnav(links, current, true);
		let items = [...nav.items];
		let usingParent = false;
		if (nav.parent) {
			usingParent = true;
			items.unshift(nav.parent);
			if (items.length > 1) items[1] = { ...items[1], showDivider: true };
		}
		if (!items.length && !primaryLabel) this.hideHorizontalNav();

		let navItems = [];

		if (primaryLabel) {
			navItems.push(
				<li>
					<a class={style.navItemHeader} href={primaryLabel.url}>
						{primaryLabel.label}
						{(primaryLabel.url === current) &&
							<div class={style.highlight} />
						}
					</a>
				</li>
			);
		}

		items.map((item, i) => {
			const highlight = (!usingParent || i > 0) && navItemIsCurrent(item, current);

			// If there's a divider, push it onto the items list
			item.showDivider &&	navItems.push(
				<li>
					<span role="separator" class={style.delimiterBar}>|</span>
				</li>
			);

			// If there's a sub divider, push it onto the items list
			item.showSubDivider &&	navItems.push(
				<li>
					<span role="separator" class={style.delimiterSlash}>|</span>
				</li>
			);

			navItems.push(
				<li>
					<LinkEvent link={item} positionIndex={i} class={style.navItem}>
						{ item.image && <img src={item.image.default || item.image[theme] || item.image} class={style.linkRendererImage} /> }
						{(!item.image && item.iconName) && <Icon name={item.iconName} class={style.linkRendererIcon} />}
						{!item.image && linkEventLabel(item)}
						{highlight && <div class={style.highlight} />}
					</LinkEvent>
				</li>
			);
		});

		return navItems;
	}

	render({ theme, links, primaryLabel, current='', scrollDirectionVertical, initialScrollDirection, allowHideNavigation }, { hideNav, handleNavScroll, disableHorizontalNav }) {
		if (disableHorizontalNav) return null;
		links = (links && Array.isArray(links)) ? links : [];
		if ((links.length === 0) && !primaryLabel) return;

		let animateNav = style.showNav;
		if (!initialScrollDirection) {
			animateNav = allowHideNavigation && scrollDirectionVertical > 0 ? style.hideNav : style.showNav;
		}

		return (
			<Column onScroll={handleNavScroll} class={cx('col-12', style.navWrapper, animateNav)}>
				<div class={cx(style.mobileHeader, style[theme])} aria-hidden={hideNav.toString()}>
					<nav
						class={style.headerNav}
						role="navigation"
						aria-controls="MOBILE-NAV-MENU"
						aria-label="Main"
						aria-haspopup="false"
						ref={(c) => this.navContent = c}
					>
						{
							<ul aria-labeledby="MOBILE-NAV-MENU">
								{
									this.renderItems(current, links, primaryLabel, theme)
								}
							</ul>
						}
						<div class={style.menuItemsCover} />
					</nav>
				</div>
			</Column>
		);
	}
}

export default MobileHorizontalNav;
